<div class="routing-groups-rules-container height-adjustment-rules-container">
  <div class="rules-title-container">
    <span class="rules-title">Routing rules</span>
    <span class="rules-title-lowercase">in</span>
    <div class="rules-title-group" *ngIf="selectedGroup">
      <div class="rules-group-name">
        <span>{{selectedGroup.name}} ({{rules.length}})'</span>
      </div>
    </div>
  </div>

  <div class="rules-container">
    <mat-accordion [multi]="true">
      <virtual-scroller cdkDropList (cdkDropListDropped)="drop($event, rulesScroll.viewPortInfo)" #rulesScroll [childHeight]="40"
                        [items]="rules" [checkResizeInterval]="100" [enableUnequalChildrenSizes]="true" class="rule-virtual-scroll">
        <mat-expansion-panel class="routing-rule-item" (cdkDragStarted)="onDrag()" *ngFor="let rule of rulesScroll.viewPortItems; let i = index"
                             [expanded]="rule.open" (click)="selectHandler(rule)" (opened)="onOpened(rule);" (closed)="onClosed(rule);"
                             (afterCollapse)="rulesScroll.refresh()" cdkDrag hideToggle>
          <mat-expansion-panel-header expandedHeight="40px" collapsedHeight="40px" class="expansion-panel-header"
                                      [ngClass]="{'selected': isSelected(rule), 'is-filtered' : rule.isFiltered}">
            <mat-panel-title>
              <div class="title">
                <span cdkDragHandle class="material-icons move-item">drag_indicator</span>
                <span title="{{rule.name}}">{{rule.name}}</span>
              </div>
            </mat-panel-title>
            <mat-panel-description class="routing-rule-description">
              <div class="routing-rule-toolbar">
                <button mat-flat-button color="primary" class="toolbar-button"
                        *ngIf="!isUnauthorized" [class.active]="rule.adminStateBoolean"
                        (click)="toggleLiveMode($event, rule)">Live</button>
                <button mat-flat-button color="primary" class="toolbar-button"
                        *ngIf="!isUnauthorized" [class.active]="rule.testModeBoolean"
                        (click)="toggleTestMode($event, rule)">Test</button>
                <span cdkDragHandle *ngIf="!isUnauthorized && isSelected(rule)" (click)="$event.stopPropagation();"
                      class="material-icons rule-options more-options" [matMenuTriggerFor]="groupMenu">more_vert</span>
                <mat-menu #groupMenu="matMenu">
                  <button mat-menu-item (click)="this.onDeleteRule($event, rule)">
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button>
                  <button mat-menu-item (click)="this.onEditRule($event, rule)">
                    <mat-icon>create</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="this.onMoveRule($event, rule)">
                    <mat-icon>open_with</mat-icon>
                    <span>Move</span>
                  </button>
                </mat-menu>
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="content-item-container">
              <div class="cell">
                <arm-form-title class="routing-rule-description-title">Conditions</arm-form-title>
                <div class="cell-content">
                  <rule-source-condition [item]="rule"></rule-source-condition>
                  <rule-destination-condition [item]="rule"></rule-destination-condition>
                  <rule-advance-condition [item]="rule"></rule-advance-condition>
                </div>
              </div>

              <div class="cell">
                <arm-form-title class="routing-rule-description-title">Actions</arm-form-title>
                <div class="cell-content">
                  <rule-action-box [item]="rule"></rule-action-box>
                </div>
              </div>
            </div>
          </ng-template>
          <div *cdkDragPreview></div>
        </mat-expansion-panel>
      </virtual-scroller>
    </mat-accordion>
  </div>
</div>

